"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
 * Use: <span data-number-counter="true" data-number-counter-delay="300" data-number-counter-tick="20">150</h2>
 * data-number-counter-delay -> optional delay time
 * data-number-counter-tick -> optional tick interval 
 */
var NumberCounter = /*#__PURE__*/function () {
  function NumberCounter(container) {
    var _this = this;

    _classCallCheck(this, NumberCounter);

    var TICK_INTERVAL = 50;
    this.container = $(container);
    this.currentValue = 0;
    this.finalValue = parseInt(this.container.text());
    this.startDelay = parseInt(this.container.data('numberCounterDelay'));
    this.tickDelay = this.container.data('numberCounterTick') ? parseInt(this.container.data('numberCounterTick')) : TICK_INTERVAL;
    this.tickInterval;
    this.largerValues = 999; //increase tick steps for number greater than this

    this.largerValuesTickStep = this.container.data('tickStep') ? parseInt(this.container.data('tickStep')) : 1; // set initial value

    this.update(); // start delay

    setTimeout(function () {
      // tick delay
      _this.tickInterval = setInterval(function () {
        _this.count();
      }, _this.tickDelay);
    }, this.startDelay);
  }

  _createClass(NumberCounter, [{
    key: "update",
    value: function update() {
      var val = parseFloat(this.currentValue).toLocaleString('en');
      this.container.text(val);
    }
  }, {
    key: "count",
    value: function count() {
      if (this.currentValue < this.finalValue) {
        this.currentValue = this.currentValue + this.largerValuesTickStep;
        this.update();
      } else {
        this.currentValue = this.finalValue;
        this.update();
        clearInterval(this.tickInterval);
        this.container.parent().find('.counterTempHiddenElement').addClass('showHiddenElement');
      }
    }
  }]);

  return NumberCounter;
}();